<template>
    <div style="width: 100%; display: flex; flex-wrap: wrap; flex-direction: column; align-items: center;">

        <v-img alt="Crossword keys" src="../assets/img/Revizor-Crossword-Puzzle-1-answers.jpg" contain max-width="800"></v-img>
        <v-img alt="Crossword keys" src="../assets/img/Revizor-Crossword-Puzzle-2-answers.jpg" contain max-width="800"></v-img>
        <v-img alt="Crossword keys" src="../assets/img/Revizor-Crossword-Puzzle-3-answers.jpg" contain max-width="800"></v-img>
        <v-img alt="Crossword keys" src="../assets/img/Revizor-Crossword-Puzzle-4-answers.jpg" contain max-width="800"></v-img>
    </div>
</template>

<script>
    export default {
        name: "Answers"
    }
</script>

<style scoped>

</style>
